<template>
  <v-container fluid :class="moduleContainerClass">
    <v-slide-y-transition mode="out-in">
      <router-view />
    </v-slide-y-transition>
    <slot name="modals"></slot>
  </v-container>
</template>
<script>
import { childOfOrEqualSome } from '../../router/functions';
export default {
  props: ["id", "inactive_routes"],
  data: function() {
    return {};
  },
  computed: {
    moduleContainerClass: function() {
      return {
        [this.id]: true,
        "dt-module": true,
        inactive: !this.moduleActive
      };
    },
    moduleActive: function() {
      return !childOfOrEqualSome([...this.inactive_routes])(this.$route.name);
    }
  }
};
</script>